import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Box, Button, Typography } from "@mui/material";

const SignaturePad = ({ onSave, setSignature }) => {
  const sigPad = useRef(null);

  const clear = () => {
    sigPad.current.clear();
    setSignature(null);
  };

  const save = () => {
    if (!sigPad.current.isEmpty()) {
      const signatureData = sigPad.current.toDataURL();
      onSave(signatureData);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
          border: "1px solid #ccc",
          mt: 1,
          backgroundColor: "#fff",
        }}
      >
        <SignatureCanvas
          ref={sigPad}
          canvasProps={{
            width: 500,
            height: 200,
            className: "signature-canvas",
          }}
          backgroundColor="rgb(255, 255, 255)"
        />
      </Box>
      <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
        <Button variant="outlined" size="small" onClick={clear}>
          Clear
        </Button>
        <Button variant="contained" size="small" onClick={save}>
          Save Signature
        </Button>
      </Box>
    </Box>
  );
};

export default SignaturePad;
